module.exports = __webpack_public_path__ + "img/icon_submenu7dark.ddc00b91.svg";